import React from "react";
import BaseComponent from "../BaseComponent";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";

export default class ParameterSubCon extends BaseComponent {
    /**
     * Submenu view for parameters, e.g. configuration, function argument
     * @module UNUSED ParameterSubCon
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.defaultAlias = "Untitled Variable";
        this.defaultVariableName = "untitled_variable";
        // Data model
        this.varModel = (this.props.data && this.props.data.variable) ? this.props.data.variable : this.initVarModel();
        // List index for this item
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel(){
        return {
            alias: this.defaultAlias,
            varName: this.defaultVariableName,
            type: null,
            value: null,
            defaultValue: null,
            constant: false
        };
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string|boolean} value
     */
    setConfig(key, value){
        this.varModel[key] = value;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        // Get current selection
        const preSelection = window.apm.knowledgeBase.getVariableTypeIndexFromValue(this.varModel.type);

        return (
            <div>
                {<Input label={this.getPropLabel("key")} hint={this.getPropLabel("key")}
                        context={this} valKey={"varName"} value={this.varModel.varName} />}
                {<Input label={this.getPropLabel("value")} hint={this.getPropLabel("value")}
                        context={this} valKey={"defaultValue"} value={this.varModel.defaultValue} />}
                {<Dropdown wide={true} label={this.getPropLabel("of_type")} optionName={this.getPropLabel("type_opt")}
                           options={window.apm.knowledgeBase.getVariableTypes()}
                           context={this} valKey={"type"}
                           selection={preSelection} />}
                {(() => {
                    if (this.varModel && this.varModel.varName){
                        // Display edit & delete for editing
                        return (
                            <table style={{width: "100%"}}><tbody><tr>
                                <td style={{paddingRight: "2px"}}>
                                    {<Button icon={"icon-trash"} tint={"warning"}
                                             callback={() => {
                                                 this.props.context.remove(this.varIdx);
                                                 this.varModel = this.initVarModel();
                                                 this.props.domContext.removeSubmenu();
                                             }}
                                    />}
                                </td>
                                <td>
                                    {<Button label={this.getPropLabel("save")} wide={true}
                                             callback={() => {
                                                 this.props.context.update(this.varModel, this.varIdx);
                                                 this.varModel = this.initVarModel();
                                                 this.props.domContext.removeSubmenu();
                                             }}
                                    />}
                                </td>
                            </tr></tbody></table>
                        );
                    }
                    return (
                        <Button label={this.getPropLabel("add")} wide={true}
                                callback={() => {
                                    if (this.varModel && this.varModel.varName) {
                                        // Add current model to item list
                                        this.props.context.add(this.varModel);
                                    }
                                    this.varModel = this.initVarModel();
                                    this.props.domContext.removeSubmenu();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}